export default {
  USER_PROFILE_REQUEST: 'APP/USER_MGMT/USER_PROFILE_REQUEST',
  USER_PROFILE_SUCCESS: 'APP/USER_MGMT/USER_PROFILE_SUCCESS',
  USER_PROFILE_ERROR: 'APP/USER_MGMT/USER_PROFILE_ERROR',
};
